import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import styles from './Filter.module.css';
import Filter from "./Filter";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faEraser} from "@fortawesome/free-solid-svg-icons";
import Sort from "./Sort";
import SortSmall from "./SortSmall";
import {useLocation, useNavigate} from "react-router-dom";

function FilterHamburger({ labelFilter, data, onFilterSubmit, filterOptionFromUrl, labelSort, dataSort, onSortSubmit, sortOptionFromUrl = '' }) {
    const [isFiltersVisible, setIsFiltersVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleFiltersVisibility = () => {
        setIsFiltersVisible(!isFiltersVisible);
    };

    const toggleFiltersReinit = () => {
        if (isFiltersVisible) setIsFiltersVisible(!isFiltersVisible);
        navigate(`${location.pathname}`);
    };

    const iconClasses = isFiltersVisible ? `${styles.hamburgerIcon} ${styles.rotateIcon}` : `${styles.hamburgerIcon}`;
    const overlayClasses = isFiltersVisible ? `${styles.overlay}` : `${styles.overlay} ${styles.overlayHide}`;

    return (
        <div className={styles.filterHamburger}>
            <div className={overlayClasses} onClick={toggleFiltersVisibility}></div>

            <button onClick={toggleFiltersReinit} className={styles.reinitButton}>
                <FontAwesomeIcon icon={faEraser}/>
            </button>

            <button onClick={toggleFiltersVisibility} className={styles.hamburgerButton}>
                <FontAwesomeIcon icon={faBars} className={iconClasses}/>
            </button>

            {isFiltersVisible && (
                <div className={styles.filtersContainer}>
                    {isFiltersVisible && (
                        <SortSmall
                            data={dataSort}
                            title={labelSort}
                            onSortSubmit={onSortSubmit}
                            sortOptionFromUrl={sortOptionFromUrl}
                        />)}
                    <Filter
                        data={data}
                        title={labelFilter}
                        onFilterSubmit={onFilterSubmit}
                        filterOptionFromUrl={filterOptionFromUrl}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterHamburger;